// extracted by mini-css-extract-plugin
module.exports = {"ImageCarousel":"ImageCarousel_ImageCarousel__3ED7c","image":"ImageCarousel_image__20xbD"};